import { ErrorMessage } from '@hookform/error-message';
import { type FieldErrors } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import Asterisk from '../Asterisk/Asterisk';
import FormError from '../FormError/FormError';
import { StyledLabel, StyledFormGroup } from './FormGroup.styles';

export interface FormGroupProps {
  children: React.ReactNode;
  htmlFor: string;
  label: string;
  hideLabel?: boolean;
  required?: boolean;
  labelTag?: React.ElementType;
  name: string;
  errors?: FieldErrors;
  className?: string;
  isHidden?: boolean;
}

const FormGroup = ({
  children,
  htmlFor,
  label,
  name,
  hideLabel = false,
  required,
  labelTag = 'label',
  errors = {},
  className,
  isHidden = false,
}: FormGroupProps) => {
  const { t } = useTranslation();

  return (
    <StyledFormGroup
      as={labelTag === 'legend' ? 'fieldset' : 'div'}
      name={name}
      className={className}
      isHidden={isHidden}
    >
      <StyledLabel
        as={labelTag}
        isHidden={hideLabel}
        htmlFor={labelTag === 'label' ? htmlFor : undefined}
      >
        {label}
        {required && <Asterisk />}
      </StyledLabel>

      {children}

      <ErrorMessage
        name={name}
        errors={errors}
        render={({ message }) => <FormError>{t(message)}</FormError>}
      />
    </StyledFormGroup>
  );
};

export default FormGroup;
